.tabs {
  display: flex;
  flex-direction: row;
  overflow: auto hidden;
  position: relative;
  scrollbar-width: none;
  width: auto;
}

.tabs:hover {
  overflow-x: auto;
  scrollbar-width: thin;
}

.tabs__direction__vertical {
  flex-direction: column;
}

.tabs__full {
  width: 100%;
}
